import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

// Initialize Sentry error monitoring
Sentry.init({
  dsn: "https://5f05330c94761bfb8e456531e8b71029@o4510616806096896.ingest.us.sentry.io/4510699933794304",
  environment: process.env.NODE_ENV,
  enabled: process.env.NODE_ENV === 'production',
  // Capture 100% of errors, sample 10% of transactions for performance
  tracesSampleRate: 0.1,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
